import React from "react";
import PorcentajeComponent from "./PorcentajeComponent";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const ChartMensajesAutomaticos = ({ data }) => {
  if (!data) return null;

  const carteraInicial = data.cartera_inicial ?? 0;
  const facCredito = data.fac_credito ?? 0;
  const totalRecuperado = data.total_recuperado ?? 0;
  const porcentaje = data.porc_recuperacion ?? 0;

  return (
    <div className="porc-recuperacion-container">
      <div className="formula-lado">
        <div className="formula-titulo-seccion">Fórmula</div>
        <div className="formula-bloque">
          <div className="formula-numerador">
            <span className="valor">{FormatMoney(totalRecuperado, 0)}</span>
          </div>
          <div className="formula-etiquetas-numerador">
            <span>Total Recuperado</span>
          </div>
          <div className="formula-linea-division"></div>
          <div className="formula-denominador">
            <span className="valor">{FormatMoney(carteraInicial, 0)}</span>
            <span className="operador">+</span>
            <span className="valor">{FormatMoney(facCredito, 0)}</span>
          </div>
          <div className="formula-etiquetas-denominador">
            <span>Cartera Inicial</span>
            <span></span>
            <span>Fac. Crédito</span>
          </div>
        </div>
      </div>

      <div className="grafica-lado">
        <PorcentajeComponent percentage={porcentaje} />
        <div className="porc-label">
          <span className="porc-numero">{porcentaje}%</span>
          <span className="porc-texto">Recuperación</span>
        </div>
      </div>
    </div>
  );
};
